import { Especialidade } from '../enums/EnumEspecialidade';
import { TipoPessoas } from '../enums/EnumTipoPessoa';
import Endereco from './Endereco';

export default class DadosMedico {
    public crm: string;

    public segundoCrm?: string;

    public ufSegundoCrm?: string;

    public especialidade?: Especialidade;

    public rqe?: number;

    public endereco!: Endereco;

    public tipoPessoa?: TipoPessoas;

    public documento: string;

    public telefone: string;

    constructor() {
      this.crm = '';
      this.documento = '';
      this.telefone = '';
      this.endereco = new Endereco();
      this.tipoPessoa = TipoPessoas.PessoaFisica;
      this.rqe = undefined;
      this.segundoCrm = '';
      this.ufSegundoCrm = '';
    }
}
